import m from "mithril";
import MessageProvider from "../../../MessageProvider"
import { Hotel, HotelResult, Location, LocationHint, LocationType } from "../../../Models";
import { getValueByLang } from "../../../Utils";
import './HotelResultComponent.css'

interface Attrs {
    messageProvider: MessageProvider;
    hotelResult: HotelResult;
    location?: Location;
    onHotelResultSelected: (hotelResult: HotelResult) => void;
    onViewImageSelected: (images:string[]) => void;
}

export default function HotelResultComponent(): m.Component<Attrs> {
    let moneyFormatter = new Intl.NumberFormat('en-US', {maximumFractionDigits: 0});
    let hotelPhotoUrls:string[] = [];
    
    let buildLocationHintDescr = (locationHint:LocationHint, messageProvider:MessageProvider) => {
        if(locationHint.type == LocationType.ATTRACTION) {
            if(locationHint.distanceInKm > 0) {
                if(locationHint.distanceInKm < 0.1) {
                    return getValueByLang(locationHint.name, messageProvider.getCurrentLang());
                } else {
                    return messageProvider.interpolate("miles_from_location", {
                        "location_name": getValueByLang(locationHint.name, messageProvider.getCurrentLang()),
                        "miles": Number(locationHint.distanceInKm / 1.6).toFixed(1)
                    });
                }
            } else {
                return messageProvider.interpolate("near_location", {
                    "location_name": getValueByLang(locationHint.name, messageProvider.getCurrentLang())
                });
            }
        } else {
            return getValueByLang(locationHint.name, messageProvider.getCurrentLang());
        }
    }

    return {
        oninit(vnode){
            hotelPhotoUrls.push(vnode.attrs.hotelResult.hotel.featuredPhotoUrl)
            vnode.attrs.hotelResult.hotel.photoUrls.forEach(photoUrl => {
                if(!hotelPhotoUrls.includes(photoUrl)){
                    hotelPhotoUrls.push(photoUrl)
                }
            })  
        },
        view(vnode) {
            const {hotelResult, messageProvider, location, onHotelResultSelected, onViewImageSelected} = vnode.attrs
            let hotel: Hotel = hotelResult.hotel;

            return [
                m("div.card ripple ripple-dark shadow rounded-25", {
                    id: hotel.id,
                    class: (location != undefined && location.type == LocationType.HOTEL && location.id == hotel.id)? " border-info" : ""
                }, [
                    m("div.row no-gutters", [
                        m("div.col-4", {
                            onclick: (event) => {
                                onViewImageSelected(hotel.photoUrls);   
                            }
                        }, [
                            m("img.card-img img-height rounded-start", {src: hotel.featuredPhotoUrl}),
                            m("div.card-img-overlay", [
                                m("button.btn btn-sm show-room-photos text-white", [
                                    m("div.font-weight-bold", m("i.bi bi-image pr-2"), messageProvider.get("photo"))
                                ])
                            ])
                        ]),
                        m("div.col-8", {
                            onclick: function (event:Event) {
                                event.preventDefault();
                                console.log("HotelResultComponent: Handling onclick event on hotel card");
                                onHotelResultSelected(hotelResult);
                            }
                        }, [
                            m("div.de-flex", [
                                m("div.p-3", [
                                    m("h5.pb-2", getValueByLang(hotel.name, messageProvider.getCurrentLang())),
                                    m("div.d-flex", [
                                        m("div", m("i.bi bi-geo-alt pr-2 text-muted")),
                                        m("div.text-muted", buildLocationHintDescr(hotel.locationHint, messageProvider))
                                    ]),
                                    m("div.d-flex pt-1", [
                                        m("div.pt-1 pr-1", m("i.bi bi-check2 pr-2 text-muted ")),
                                        m("div", {class: (hotel.valueAddedPromotion != null)? "ellipsis-more-than-one-line ellipsis-color": "ellipsis-more-than-two-line ellipsis-color"},
                                            hotel.amenities.map((amenity, index) => {
                                                let amenityStr: string = ""
                                                if(index < hotel.amenities.length -1){
                                                    amenityStr += getValueByLang(amenity.label, messageProvider.getCurrentLang()) + 
                                                        ((messageProvider.getCurrentLang() == "en")?", ": "၊ ")
                                                }else{
                                                    amenityStr += getValueByLang(amenity.label, messageProvider.getCurrentLang())
                                                }
                                                return m("span.text-sm-left pr-1 text-muted", amenityStr)
                                            })
                                        )    
                                    ]),
                                    (hotel.valueAddedPromotion != null)?
                                    [
                                        m("div.pt-2 d-flex", [
                                            m("div", m("i.bi bi-gift text-accent-dark pr-1")),
                                            m("div.ellipsis-more-than-two-line font-weight-bold",
                                                getValueByLang(hotel.valueAddedPromotion.shortMessage, messageProvider.getCurrentLang())
                                            )
                                        ]),
                                    ]:null
                                ]),
                                (hotel.isPromoAvailable && hotelResult.rateSummary.discountAppliedSummary != null)?
                                m("div", 
                                    m("div.hotel-promotion" , 
                                        m("span.hotel-promotion-content", ` ${hotelResult.rateSummary.discountAppliedSummary.discountPercentage}% Off `)
                                    )
                                ):null
                            ])
                        ])
                    ]),
                    m("div.row px-3 py-2 border-top", [
                        m("div.col-4"),
                        m("div.col-8 text-right", [
                            (!hotel.hasAllotment) ? 
                            m("div",
                                m("h6.text-right", m("span.badge badge-danger", "SOLD OUT")),
                            ):null,
                            m("div", { class: "text-accent-dark" }, [   
                                (hotel.isPromoAvailable && hotelResult.rateSummary.discountAppliedSummary != null) ? 
                                m("small", { class: "hotel-price-overriden text-dark mr-2" }, 
                                        "MMK " + moneyFormatter.format(
                                            hotelResult.rateSummary.standardRateSummary.minimumAmount + 
                                            hotelResult.rateSummary.discountAppliedSummary.discountAppliedOnMinimumAmount
                                )) : null, 
                            
                                m("span.total-rate", m("b", "MMK " + moneyFormatter.format(hotelResult.rateSummary.standardRateSummary.minimumAmount)))                                 
                            ]),
                            m("div", { class: "text-muted" }, messageProvider.get("from"))
                        ])
                    ])
                ])
            ] 
        }
    }
}